import MessageApi from '../../../../api/inbox/message';

export default {
  // DENG-7236 — record a Moni-note grade. Merges cs_ai_feedback onto the note's
  // content_attributes via the existing messages#update route; the resulting
  // message.updated webhook is ingested by cs-ai-agent (DENG-7235). Best-effort:
  // a failed grade must not surface an error to the agent (internal tooling).
  // DENG-7319 — an optional free-text `comment` is included when non-empty; an
  // empty/whitespace comment is omitted so the grade clears it server-side. The
  // full cs_ai_feedback is always sent (Rails shallow-merges content_attributes).
  // DENG-7358 — resolves true/false (never throws) so the widget can show an
  // honest "saved" vs "couldn't save" confirmation instead of a swallowed error.
  async rateAiMessage(_, { conversationId, messageId, rating, ratedBy, comment }) {
    const csAiFeedback = {
      rating,
      rated_at: new Date().toISOString(),
      rated_by: ratedBy,
    };
    const trimmedComment = comment?.trim();
    if (trimmedComment) {
      csAiFeedback.comment = trimmedComment;
    }
    try {
      await MessageApi.updateContentAttributes(conversationId, messageId, {
        cs_ai_feedback: csAiFeedback,
      });
      return true;
    } catch (error) {
      return false;
    }
  },

  // DENG-8011 — record that the agent clicked "Usar respuesta" on a Moni note. Written
  // as its OWN top-level content_attributes key (Rails shallow-merges only at the top
  // level, so cs_ai_response_use and a sibling cs_ai_feedback grade preserve each other —
  // do NOT nest it inside cs_ai_feedback). The resulting message.updated webhook is
  // ingested by cs-ai-agent (ResponseUsageIngestionService). Best-effort like
  // rateAiMessage: resolves true/false, never throws — a failed capture must not surface
  // an error to the agent nor block the composer insertion.
  async recordAiResponseUse(_, { conversationId, messageId, usedBy, usedByName }) {
    const csAiResponseUse = {
      used_at: new Date().toISOString(),
      used_by: usedBy,
    };
    if (usedByName) {
      csAiResponseUse.used_by_name = usedByName;
    }
    try {
      await MessageApi.updateContentAttributes(conversationId, messageId, {
        cs_ai_response_use: csAiResponseUse,
      });
      return true;
    } catch (error) {
      return false;
    }
  },
};
